import { SystemRoleInsert, SystemRoleDelete, SystemRoleUpdate, SystemRoleGetById, SystemRoleGetList, SystemRoleGetPageList } from "@/api/systemrole/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    SystemRoleInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemRoleInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemRoleUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemRoleUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemRoleGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemRoleGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemRoleGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemRoleGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemRoleGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemRoleGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}